export const userConstants = {
    REGISTER_REQUEST:     'USERS_REGISTER_REQUEST',
    REGISTER_SUCCESS:     'USERS_REGISTER_SUCCESS',
    REGISTER_FAILURE:     'USERS_REGISTER_FAILURE',

    PASSWORD_REQUEST:     'USERS_PASSWORD_REQUEST',
    PASSWORD_SUCCESS:     'USERS_PASSWORD_SUCCESS',
    PASSWORD_FAILURE:     'USERS_PASSWORD_FAILURE',
}